import React from "react"

import { useAuth } from "@/contexts/AuthContext"
import { Navigate, useLocation } from "react-router-dom"

import { cn } from "@/lib/utils"
import logo from '@/assets/logo.png'

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

import { LoaderCircleIcon, ShieldAlertIcon } from "lucide-react"
import { supabase } from "@/lib/supabase"

interface UserAuthFormProps extends React.HTMLAttributes<HTMLDivElement> { }



export default function Login() {
  const { session } = useAuth()
  const location = useLocation()

  if (session) {
    return <Navigate to={location.state?.pathname || '/payments'} />
  }

  return (
    <>
      <div className="w-screen relative flex h-screen flex-col items-center justify-center items-center">
        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px] relative bottom-16">
          <div className="flex flex-col space-y-2 text-center">
            <div className="relative z-20 flex items-center text-center justify-center text-lg font-medium gap-2 flex-col mb-2">
              <img src={logo} className="h-8 w-8" />
              Universus
            </div>
            <h1 className="text-2xl font-semibold tracking-tight">
              Welcome Back
            </h1>
            <p className="text-sm text-muted-foreground">
              Connectez-vous à votre compte
            </p>
          </div>
          <LoginForm />
        </div>
      </div>
    </>
  )
}

export function LoginForm({ className, ...props }: UserAuthFormProps) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [email, setEmail] = React.useState<string>('')
  const [password, setPassword] = React.useState<string>('')
  const [error, setError] = React.useState<string>(false)

  async function onFinish(event: React.SyntheticEvent) {
    event.preventDefault()

    setIsLoading(true)

    const { error } = await supabase.auth.signInWithPassword({
      email, password
    })

    setIsLoading(false)

    if (error) {
      setError(true)
    }
  }

  return (
    <div className={cn("grid gap-6", className)} {...props}>
      <form onSubmit={onFinish}>
        <div className="grid gap-2">
          <div className="grid gap-1">
            <Input
              placeholder="Email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value)
              }}
            />
          </div>
          
          <div className="grid gap-1">
            <Input
              placeholder="Mot de passe"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          
          <Button disabled={isLoading}>
            {isLoading && (
              <LoaderCircleIcon className="mr-2 h-4 w-4 animate-spin" />
            )}
            Se connecter
          </Button>

          <div className="min-h-[1.5rem] flex items-center justify-center text-xs text-red-500 transition-opacity duration-300">
            {error && (
              <>
                <ShieldAlertIcon className="w-4 h-4 mr-2" />
                Adresse e-mail ou mot de passe incorrect.
              </>
            )}
          </div>
        </div>
      </form>
    </div>
  )
}